export default {
  deletePopup: {
    ar: "هل انت متأكد من انك تريد حذف هذا المورد ؟",
    en: "Are you sure you want to delete this broker ?"
  }
}